import React from 'react'
import renderHTML from 'react-render-html'
import './styles.scss'

export class Post extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      bubbles: []
    }
  }

  setSource(name) {
    try {
      const src = require('../../images/' +
        name.replace(/\s+/g, '').toLowerCase() +
        '.jpg')
      return src
    } catch (err) {
      return require('../../images/_dummy.jpg')
      // Do whatever you want when the image failed to load here
    }
  }

  urlify(text) {
    const urlRegex = /(https?:\/\/[^\s]+)/g
    return text.replace(urlRegex, function(url) {
      return '<a href="' + url + '" target="_top">' + url + '</a>'
    })
    // or alternatively
    // return text.replace(urlRegex, '<a href="$1">$1</a>')
  }

  imagefy(text) {
    let output = text
    if (text.includes('image:')) {
      const textStrings = text.split('image:')
      output =
        '<img src="https://storage.googleapis.com/ta-interaktiv/messenger-chat/images/' +
        textStrings[1] +
        '" />'
    }
    return output
  }

  componentDidMount() {
    const bubbles = this.props.bubbles.map(
      function(bubble, index) {
        console.log('bubble', bubble)
        return (
          <>
            {this.props.side === 'left' &&
              index === 0 &&
              this.props.name !== 'SYSTEM' && (
                <>
                  <div className='person'>
                    <img
                      className='ui avatar image'
                      src={this.setSource(this.props.name)}
                    />
                    <div className='name'>
                      {this.props.name === null ? 'NoName' : this.props.name}
                    </div>
                  </div>
                  <div
                    className={
                      index === 0
                        ? 'bubble first'
                        : index === this.props.bubbles.length - 1
                        ? 'bubble last'
                        : 'bubble middle'
                    }
                  >
                    {renderHTML(this.imagefy(this.urlify(bubble.Message)))}
                  </div>
                </>
              )}
            {this.props.side === 'right' &&
              index === 0 &&
              this.props.name !== 'SYSTEM' && (
                <>
                  <div
                    className={
                      index === 0
                        ? 'bubble first'
                        : index === this.props.bubbles.length - 1
                        ? 'bubble last'
                        : 'bubble middle'
                    }
                  >
                    {renderHTML(this.imagefy(this.urlify(bubble.Message)))}
                  </div>
                  <div className='person'>
                    <img
                      className='ui avatar image'
                      src={this.setSource(this.props.name)}
                    />
                    <div className='name'>
                      {this.props.name === null ? 'NoName' : this.props.name}
                    </div>
                  </div>
                </>
              )}
            {index > 0 &&
              index < this.props.bubbles.length &&
              this.props.name !== 'SYSTEM' && (
                <div
                  className={
                    index === 0
                      ? 'bubble first'
                      : index === this.props.bubbles.length - 1
                      ? 'bubble last'
                      : 'bubble middle'
                  }
                >
                  {renderHTML(this.imagefy(this.urlify(bubble.Message)))}
                </div>
              )}
            {this.props.name === 'SYSTEM' && (
              <div className='hint>'>{bubble.Message}</div>
            )}
          </>
        )
      }.bind(this)
    )
    this.setState({ bubbles: bubbles })
  }

  render() {
    return (
      <div
        className={
          this.props.name === 'SYSTEM'
            ? 'system'
            : this.props.name === null
            ? 'post ' + this.props.side
            : 'post ' +
              this.props.side +
              ' ' +
              this.props.bubbleColors[this.props.name.toLowerCase()]
        }
        // key={'k-' + this.props.date}
      >
        <div className='timestamp'>{this.props.date}</div>
        <div className='block'>{this.state.bubbles}</div>
      </div>
    )
  }
}
